<template>
    <div class="user-info-link">
        <el-table border :data="customerInfo">
            <el-table-column label="客户信息">
                <template slot="header" slot-scope="scope">
                    <span>客户信息</span>


                </template>
                <template slot-scope="scope">
                    <el-form label-width="80px" size="mini">
                        <div class="block"><el-avatar :size="50" :src="scope.row.headImageUrl"></el-avatar></div>
                    </el-form>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12">
                            <el-form :model="scope.row" class="demo-form-inline" label-width="80px" size="mini">
                                <el-form-item label="昵称">
                                    <el-input v-model="scope.row.nickName" placeholder="无" :disabled="true"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form :model="scope.row" class="demo-form-inline" label-width="80px" size="mini">

                                <el-form-item label="手机" class="red">
                                    <el-input v-model="scope.row.mobile" placeholder="无" type="number" maxlength="11" :disabled="true"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-form label-width="80px" size="mini">
                        <el-form-item label="OPENID">
                            <el-input v-model="scope.row.openId" placeholder="无" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="CUSID">
                            <el-input v-model="scope.row.customerId" placeholder="无" :disabled="true"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-form label-width="80px" size="mini">
                        <el-form-item label="">
                            <el-button type="success" size="mini" class="header-btn" @click="handleCmsDetail">查看详情(CMS)</el-button>
                            <el-link :href="getLink(1)" target="_blank">
                                <el-button type="success" size="mini" class="header-btn">查看详情(新窗口CMS)</el-button>
                            </el-link>
                        </el-form-item>
                        <el-form-item label="">
                            <el-link :href="getLink(2)" target="_blank">
                                <el-button type="primary" size="mini" class="header-btn">查看详情(新窗口ERP)</el-button>
                            </el-link>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getCustomerList,saveCusertomerUserServiceApi} from '@/api/api';


    //定义组件
    export default {
        data() {
            return {
                customerInfo:[{}],
                formInline: {
                    currentPage: 1,
                    pageSize: 10,
                    isOnLine: 0,
                    nickName:'',
                    mobile:'',
                    openId:this.GetQueryString('partnerId')||'',
                    customerId:''
                },
            }
        },
        //挂载时候执行
        mounted() {
            this.getCustomerLineList();
            console.log(this.GetQueryString('partnerId'));
            //this.saveCusertomerUserService();
        },
        methods: {
            saveCusertomerUserService() {
                    saveCusertomerUserServiceApi({"openId":this.formInline.openId}).then((res) => {
                })
            },
            getCustomerLineList() {
                this.loading = true;
                getCustomerList(this.formInline).then((res) => {
                    this.customerInfo = res.data.value.list.length>0?[res.data.value.list[0]]:[{}]
                    this.formInline.customerId = this.customerInfo[0].customerId?this.customerInfo[0].customerId:''
                })
            },
            handleCmsDetail() {
                console.log(this.formInline.customerId)
                if(this.formInline.customerId==''){
                    this.$notify({
                        title: '错误',
                        message: '用户不存在,请重试',
                        type: 'error'
                    });
                }else{
//                    window.location.href = `https://cms.lechun.cc/#/usersystem/detail/${this.formInline.customerId}`
                    this.$router.push({path:'/userSystem/detail/:id',name: 'userSystemContent',params:{id:this.formInline.customerId}})

                }
            },
            getLink(stat){
                let returnUrl = ''
                if(stat=='1'){
                    console.log('看看url:'+`https://csms.lechun.cc/userDetail/${this.formInline.customerId}`);
                    returnUrl = `${window.location.origin}/#/usersystem/detail/${this.formInline.customerId}`
                }else if(stat=='2'){
                    returnUrl = `//erpnew.lechun.cc/mall_customer_edit.html?customerid=${this.formInline.customerId}`
                }
                return returnUrl
            },
            handleClose(done){
                done()
                this.getCustomerLineList()
            },
            GetQueryString(name){
                let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
                let sp = 'userinfo'||'userInfo'
                let u=window.location.hash.split(sp)[1].substr(1);
                u= u.replace(/amp;/g,"");
                let r = u.match(reg);
                if(r!=null)return  decodeURIComponent(r[2]);
                return "";
            }

        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .user-info-link{
        .el-input.is-disabled .el-input__inner{
            color: #8c8c8c;
        }
        .button-to{
            margin-right: 10px;
            margin-bottom: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/userSystem/userInfo.vue